import BaseItem, { FormItemProps as BaseProps } from 'antd/lib/form/FormItem'

export type { ValidateStatus } from 'antd/lib/form/FormItem'

export interface FormItemProps<Values>
  extends Omit<BaseProps<Values>, 'colon'> {}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function FormItem<Values = any>(props: FormItemProps<Values>): JSX.Element {
  return (
    <>
      <BaseItem colon={false} {...props} />
    </>
  )
}

export default FormItem
